// extracted by mini-css-extract-plugin
module.exports = {"link":"_1410bfd27b--link--X0vCh","all-category":"_1410bfd27b--all-category--z2h4W","icon":"_1410bfd27b--icon--Ehtpi","text":"_1410bfd27b--text--c1SY6"};